import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import commonStrings from 'modules/common/strings';
import { status } from 'constants/general';
import Loader from 'modules/common/components/Loader';

import {
  Wrapper,
  UserNameWrapper,
  UserName,
  LogoutPopup,
  Logout,
  UserNameLoaderWrapper,
} from './Header.style';
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const Header = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const { loginInfo } = useSelector(state => ({ loginInfo: state.accountManagement.loginInfo }));

  const userNameWrapperRef = useRef(null);
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [isLogoutPopupOpen, setIsLogoutPopupOpen] = useState(false);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    const handleClickOutside = event => {
      if (userNameWrapperRef.current && userNameWrapperRef.current.contains(event.target) === false)
        setIsLogoutPopupOpen(false);
    };
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [userNameWrapperRef]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleUsernameClick = () => {
    setIsLogoutPopupOpen(prevState => !prevState);
  };

  const handleLogoutClick = () => {
    setIsLogoutPopupOpen(false);

    Cookies.remove('auth');
    Cookies.remove('hbReturnURL');
    document.location.href = '/login';
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <Wrapper>
      {((loginInfo.status === status.SHOULD_CALL_API || loginInfo.status === status.FETCHING) && (
        <UserNameLoaderWrapper>
          <Loader width={16} height={16} thickness={4} />
        </UserNameLoaderWrapper>
      )) ||
        (loginInfo.details?.Name && (
          <UserNameWrapper ref={userNameWrapperRef}>
            <UserName
              onClick={() => handleUsernameClick()}
            >{`${commonStrings.header.userNameText} ${loginInfo.details.Name}`}</UserName>
            {isLogoutPopupOpen && (
              <LogoutPopup>
                <Logout onClick={() => handleLogoutClick()}>
                  {commonStrings.header.logoutText}
                </Logout>
              </LogoutPopup>
            )}
          </UserNameWrapper>
        ))}
    </Wrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
